import React, { Component } from 'react';

import "./Scroller.items.scss"

//const evnURL = `http://source-qa.a.ynet.co.il/secure/mShort/content/2018/70years/uploads/`
const evnURL = `https://z.ynet.co.il/mShort/content/2017/70years/uploads/`

class ScrollerItems extends Component {
    componentDidMount() {
        this.props.itemNode(this.node, this.props.index);
    }
    render() {
        return (
            <div data-index={this.props.index} className="item" ref={(node) => { this.node = node }}>
                <a href={this.props.item.link} title="" target="_blank">
                    <div className="image">
                        <img src={`${evnURL}${this.props.item.image}`} alt="" />
                    </div>
                    <div className="desc">
                        {this.props.item.name}
                    </div>
                </a>
            </div>
        );
    }
}

export default ScrollerItems;



// WEBPACK FOOTER //
// ./src/Components/App/ScrollerItems.js